// Dependencies
import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RouteComponentProps } from "react-router-dom";

// Components
import ForbiddenMessage from "components/ForbiddenMessage";
import LessonPlansScreen from "screens/LessonPlan/lesson-plan";
import Spinner from "components/Spinner";
import { NotFoundProject as ForbiddenContainer } from "screens/Projects/Details/styles";

// Redux
import { Creators as LessonPlanActions } from "store/ducks/lesson-plan";

// Services
import history from "services/history";

// Helpers
import { IReduxStore } from "interfaces/IReduxStore";
import { ILessonPlanState, ILessonPlanActions } from "store/interfaces/ILessonPlan";
import { ternary } from "utils/ternary";

interface ILessonPlanContainerProps {
    course: {
        isPublished: boolean;
        forbiddenText?: string;
        slug?: string;
    };
    lessonPlan: ILessonPlanState;
    lessonPlanActions: ILessonPlanActions;
    menu: any;
    zoneName: string;
}

const LessonPlanContainer = (props: ILessonPlanContainerProps & RouteComponentProps<{ idModule?: string; day?: string }, {}, { day: string }>) => {
    const { course, menu, ...rest } = props;

    const lessonPlanMenu = menu.find((item: any) => ["plano-de-estudos"].includes(item.url.split("/").pop()));

    const loadLessonPlan = useCallback(() => {
        return props.lessonPlanActions.getLessonPlanRequest();
    }, [props.lessonPlanActions]);

    useEffect(() => {
        loadLessonPlan();
    }, [loadLessonPlan]);

    useEffect(() => {
        if (!course.isPublished && !!props.lessonPlan.id) {
            props.lessonPlanActions.clearLessonPlan();
            history.push({ pathname: `/app/curso/${course.slug}/plano-de-estudos` });
        }
    }, [course.isPublished, course.slug, props.lessonPlan, props.lessonPlan.id, props.lessonPlanActions]);

    if (!!props.lessonPlan.isLoading) {
        return <Spinner fixed />;
    }

    if (!props.lessonPlan.isPublished || props.lessonPlan.hasError) {
        const forbiddenMessageText = ternary([
            [!!props.lessonPlan.helptext, props.lessonPlan.helptext],
            [!lessonPlanMenu?.name, "Plano de estudos não encontrado."],
            [lessonPlanMenu?.name === "Agenda de aulas", "Agenda de aulas não encontrada."],
            [lessonPlanMenu?.name === "Lives", "Lives não encontradas."],
            [lessonPlanMenu?.name === "Sala virtual", "Sala virtual não encontrada."],
            [lessonPlanMenu?.name === "Espaço meet", "Espaço meet não encontrado."],
            [lessonPlanMenu?.name === "Aulas", "Aulas não encontradas."],
            [lessonPlanMenu?.name === "Ao vivo", "Aulas ao vivo não encontradas."],
            [true, "Plano de estudos não encontrado."]
        ]) as string;

        return (
            <ForbiddenContainer>
                <ForbiddenMessage text={forbiddenMessageText} />
            </ForbiddenContainer>
        );
    }

    return <LessonPlansScreen {...rest} />;
};

const mapStateToProps = (state: IReduxStore) => ({
    course: {
        isPublished: state.course.isPublished,
        forbiddenText: state.course.helptext,
        slug: state?.course?.slug
    },
    menu: state.auth.menu,
    lessonPlan: state.lessonPlan,
    zoneName: state.credentials.timezone.zoneName
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    lessonPlanActions: bindActionCreators(LessonPlanActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LessonPlanContainer);
